import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';

import { getClientFilterFn } from './clientFilterFns';

// Filter in-memory using the same value encodings the cip filter widgets produce.
export const useClientFilterableColumns = <T>(columns: ColumnDef<T, any>[]): ColumnDef<T, any>[] =>
    useMemo(
        () =>
            columns.map(
                (column) =>
                    ({
                        ...column,
                        filterFn: getClientFilterFn(column.meta?.filterType, {
                            isPercentage: column.meta?.isPercentage,
                            percentDecimals: column.meta?.percentDecimals,
                        }),
                    }) as ColumnDef<T, any>,
            ),
        [columns],
    );
